import {hintCardType} from "../components/Members/HintCardText";

export const getMembersType = ({projId,stratId,portfolioId,policyId}) => {
    if(policyId){
        return hintCardType.policy
    }else if (stratId && (!portfolioId && !projId)){
        return  hintCardType.strat
    } else if (portfolioId && stratId){
        return hintCardType.portfolio
    }else return hintCardType.proj
}
